import { FRONT_COLUMNS } from "../front";
import { CAMPAIGNS_COLUMNS } from "./campains";
import { MARKETING_PLAN_COLUMNS } from "./marketingPlan";
import { NAVIGATION_COLUMNS } from "./navigation";
import { NOTIFICATIONS_COLUMNS } from "./notifications";
import { OPERATION_COLUMNS, OPERATION_ITEMS_COLUMNS } from "./operations";
import { PRICES_COLUMNS } from "./prices";
import { PROJECT_COLUMNS } from "./projects";
import { QUOTES_COLUMNS } from "./quotes";
import { SERVICES_COLUMNS } from "./services";
import { PARENT_TASKS_COLUMNS, TASKS_COLUMNS } from "./tasks";
import { USERS_COLUMNS } from "./users";

export const ALL_MONDAY_COLUMNS = [
	TASKS_COLUMNS,
	PARENT_TASKS_COLUMNS,
	CAMPAIGNS_COLUMNS,
	MARKETING_PLAN_COLUMNS,
	OPERATION_COLUMNS,
	OPERATION_ITEMS_COLUMNS,
	PRICES_COLUMNS,
	PROJECT_COLUMNS,
	SERVICES_COLUMNS,
	TASKS_COLUMNS,
	PARENT_TASKS_COLUMNS,
	FRONT_COLUMNS,
	USERS_COLUMNS,
	QUOTES_COLUMNS,
	NOTIFICATIONS_COLUMNS,
	NAVIGATION_COLUMNS,
].flatMap((obj) => Object.entries(obj));
